export default async function sendJson(
  method: 'GET' | 'POST',
  url: string,
  body?
) {
  const options = {
    method,
    body: method !== 'GET' ? JSON.stringify(body) : undefined,
    headers: { 'Content-type': 'application/json; charset=utf-8' }
  };

  try {
    const response = await fetch(url, options);

    if (response.ok) {
      if (response.status === 204) {
        return { result: null, statusCode: response.status };
      }
      const json = await response.json();
      return { result: json, statusCode: response.status };
    }

    return { result: null, statusCode: response.status };
  } catch (e) {
    if (e.name === 'AbortError') return { result: null, statusCode: 20 };
    return { result: null, statusCode: 502 };
  }
}

export const handleResponseStatus = (status, successFunc, failFunc) => {
  if (status >= 200 && status <= 299) successFunc();
  if (status >= 400 && status <= 499) {
    if (status === 401) window.location.pathname = '/signin';
    else failFunc();
  }
  if (status >= 500 && status <= 599) failFunc();
};
